module.exports = __webpack_public_path__ + "static/favicon-167-touch-0421d7324033759e375895d35fe657fd.png";